import axios from 'axios';
const baseUrl = process.env.VUE_APP_TAPTAGS_API_URL;
export const fetcher = axios.create({baseURL: baseUrl, withCredentials: true});
